//TODO : this file is no longer needed!

export enum FEEDBACK_MESSAGE_TYPE {
	NO_CHANGES_TO_UPDATE = "No changes to update!",
	SOMETHING_WENT_WRONG = "Något gick fel",
	RESEND_FAILED = "Försöket att skicka om koden misslyckades.",
	RESEND_SUCCESSFUL = "Omförsändelsen av koden lyckades.",
	CHANGES_SAVE_SUCCESSFULLY = "Ändringarna sparades",
	RESET_PASSWORD_LINK_SENT = "Ett e-post om lösenordsbyte har skickats",
	RESET_PASSWORD_SUCCESS = "Lösenordet har sparats!",
	ANOTHER_ACCOUNT_FOUND_ERROR_MESSAGE = "Ett annat konto har redan registrerats med denna e-post",
}
